import { type Table } from "@tanstack/react-table";
import { exportDataToCsv } from "@/utils/exportToCsv";
import { Button } from "@/components/ui/button";
import { DataTable } from "@/components/data-table/data-table";
import UserLayout from "@/features/layout";
import { columns } from "./components/users-columns";
import { UsersDialogs } from "./components/users-dialogs";
import { UsersPrimaryButtons } from "./components/users-primary-buttons";
import { User, userListSchema } from "./data/schema";
import { users } from "./data/users";

export default function Users() {
  const userList = userListSchema.parse(users);

  const floatingActionItems = (table: Readonly<Table<User>>) => {
    const selectedCount = table.getSelectedRowModel().rows.length;

    return [
      <div
        key="selectedCount"
        className="text-muted-foreground mr-2 flex items-center text-sm"
      >
        {selectedCount} selected
      </div>,
      <Button
        key="export-csv"
        variant="default"
        size="sm"
        className="space-x-1"
        onClick={() => exportDataToCsv(userList, "users.csv")}
      >
        <span>Export CSV</span>
      </Button>,
    ];
  };

  return (
    <UserLayout
      pageTitle="User List"
      pageDescription="Manage your users and their roles here."
      rightContent={<UsersPrimaryButtons />}
    >
      <div className="-mx-4 flex-1 overflow-auto px-4 py-1 lg:flex-row lg:space-x-12 lg:space-y-0">
        <DataTable
          tableId="users"
          data={userList}
          columns={columns}
          searchColumn="username"
          searchPlaceholder="Filter users..."
          facetedFilters={[
            {
              columnId: "status",
              title: "Status",
              options: [
                { label: "Active", value: "active" },
                { label: "Inactive", value: "inactive" },
                { label: "Invited", value: "invited" },
                { label: "Suspended", value: "suspended" },
              ],
            },
            {
              columnId: "role",
              title: "Role",
              options: [
                { label: "Superadmin", value: "superadmin" },
                { label: "Admin", value: "admin" },
                { label: "Manager", value: "manager" },
                { label: "Cashier", value: "cashier" },
              ],
            },
          ]}
          floatingActionItems={(table) => floatingActionItems(table)}
        />
      </div>

      <UsersDialogs />
    </UserLayout>
  );
}
